<template>
  <div id="wrapper" class="wrapper" style="height: auto; min-height: 100%;">
    <input type="hidden" name="_token" :value="csrf">
    <navbar-header v-if="this.getAuth.isLoggedIn"></navbar-header>
    <sidebar v-if="this.getAuth.isLoggedIn"></sidebar>
    <router-view/>
    <footer-abft v-if="this.getAuth.isLoggedIn"></footer-abft>
  </div>
</template>

<script>
  import navbarHeader from './components/Communs/navbar-header'
  import sidebar from './components/Communs/sidebar'
  import footerAbft from './components/Communs/Footer'
  import {mapGetters, mapActions} from 'vuex'
  import Auth from '@/auth'

  export default {
    name: 'App',
    data() {
      return {
        csrf: "",
        // auth: this.getAuth,
        // auth: {},
      }
    },
    computed: {
      ...mapGetters({
        getAuth: 'getAuth',
        getMember: 'getMember',
        getProfessions: 'getProfessions',
        getPays: 'getPays',
        getRoutes: 'getRoutes',
        getVilles: 'getVilles',
        getRoute: 'getRoute',
        getTypesLicences: 'getTypesLicences',
        getStatutsSportifs: 'getStatutsSportifs',
        getProdVersion: 'getProdVersion',
      })
    },
    methods: {
      ...mapActions({
        setProfessions: 'setProfessions',
        setPays: 'setPays',
        setVilles: 'setVilles',
        setMember: 'setMember',
        setTypesLicences: 'setTypesLicences',
        setStatutsSportifs: 'setStatutsSportifs',
        setMajNixinut: 'setMajNixinut',
      }),
      loadTypesLicences: function () {
        this.$http.get(this.getRoute('getAllTypesLicences')).then((response) => {
          this.setTypesLicences(response.body)
        }, (response) => {
        });
      },
      loadStatutsSportifs: function () {
        this.$http.get(this.getRoute('getAllStatutsSportifs')).then((response) => {
          this.setStatutsSportifs(response.body)
        }, (response) => {
        });
      },
      loadPays: function () {
        this.$http.get(this.getRoute('getAllPays')).then((response) => {
          this.setPays(response.body)
        }, (response) => {
        });
      },
      loadVilles: function () {
        this.$http.get(this.getRoute('getAllVilles')).then((response) => {
          this.setVilles(response.body)
        }, (response) => {
        });
      },
      loadProfessions: function () {
        this.$http.get(this.getRoute('getAllProfessions')).then((response) => {
          this.setProfessions(response.body)
        }, (response) => {
        });
      },
      loadMajNixinut: function () {
        this.$http.get(this.getRoute('getMajNixinut')).then((response) => {
          this.setMajNixinut(response.body.data)
        }, (response) => {
        });
      },
      checkVersion: function () {
        this.$http.get(this.getRoute('versionIntranet')).then((response) => {
          if (response.body!=this.getProdVersion)
            location.reload(true);
        }, (response) => {
        });
      },
    },
    watch: {
      'getAuth.isLoggedIn': function () {
        if (!this.getAuth.isLoggedIn)
          return
        this.checkVersion()
        this.loadPays()
        this.loadVilles()
        this.loadProfessions()
        this.loadTypesLicences()
        this.loadStatutsSportifs()
        this.loadMajNixinut()
      }
    },
    mounted: function () {
      if (!this.getAuth.isLoggedIn)
        return
      let these = this
      this.checkVersion()
      this.loadPays()
      this.loadVilles()
      this.loadProfessions()
      this.loadTypesLicences()
      this.loadStatutsSportifs()
      this.loadMajNixinut()
    },
    components: {
      navbarHeader,
      footerAbft,
      sidebar
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue